import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/admin/add-client/[id]/risk-center/page";

export const Route = createFileRoute("/admin/add-client/$clientId/risk-center")(
  {
    component: Page,
  },
);
